module.exports = __webpack_public_path__ + "static/media/badge4.1d581e1e.svg";